import * as AuthActions from './auth.action';
import {LocalStorageUtils} from '../../shared/util/local-storage.utils';

export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  profile: any | null;
  errorMessage: string | null;
}

const initialState: AuthState = {
  isAuthenticated: LocalStorageUtils.isExistAccessToken(),
  token: LocalStorageUtils.isExistAccessToken() ? LocalStorageUtils.getAccessToken() : null,
  profile: LocalStorageUtils.isExistAccessToken() ? JSON.parse(LocalStorageUtils.getItem('profile')) : {},
  errorMessage: null
};

export function authReducer(
  state = initialState,
  action: AuthActions.AuthActions
  ) {

  switch (action.type) {

    case AuthActions.SIGN_IN:
      return {
        ...state,
        authenticated: false
      };

    case AuthActions.SIGN_IN_SUCCESS:
      const profile = action.payload.profile;
      const accessToken = action.payload.profile.access_token;
      LocalStorageUtils.saveAccessToken(accessToken);
      LocalStorageUtils.saveValue('profile', JSON.stringify(profile));
      return {
        ...state,
        isAuthenticated: true,
        token: accessToken,
        profile: profile,
        errorMessage: null
      };

    case AuthActions.SIGN_IN_ERROR:
      return {
        ...state,
        isAuthenticated: false,
      };

    case AuthActions.LOG_OUT:
      const profileLogOut = {};
      const accessTokenLogOut = '';
      LocalStorageUtils.removeAccessToken();
      LocalStorageUtils.removeItem('profile');
      return {
        ...state,
        isAuthenticated: false,
        token: accessTokenLogOut,
        profile: profileLogOut,
        errorMessage: null
      };

    default:
      return state;
  }
}
